export default __webpack_public_path__ + "static/atlantis-the-palm-41891853eec3179e6f9c051e77604eee.jpg";